export interface JWTClaims {
    email?: string
    ime?:   string
    exp?:   number   // seconds since epoch (RegisteredClaims.ExpiresAt)
}

/**
 * Reads the token's claims WITHOUT verifying it — the browser has no key and does not need
 * one: this only decides what to render. Every API call is still verified by the server.
 * The payload is base64url JSON in UTF-8 (names carry č, š, ž), hence the TextDecoder.
 */
export const parseJWT = (jwt: string): JWTClaims | null => {
    const payload = jwt.split('.')[1]
    if (!payload) return null

    try {
        const bytes = Uint8Array.from(atob(payload.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0))
        return JSON.parse(new TextDecoder().decode(bytes)) as JWTClaims
    } catch {
        return null
    }
}

/**
 * Present, well-formed and not expired — 30s early, so a token does not die mid-render.
 * A token WITHOUT `exp` is invalid (the API requires `exp`); the template accepts it.
 */
export const isJWTValid = (jwt: string): boolean => {
    const claims = parseJWT(jwt)
    if (!claims || typeof claims.exp !== 'number') return false
    return claims.exp * 1000 > Date.now() + 30_000
}
